import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { BASE_URL, FIND_USER_SUBPASS, RESET_SUBPASS, FETCH_RESET_SUBPASS_LOG, M_POST } from '@/utils/api';

import type { IUsername } from '@/interface/SecretPassword';

@Module({ name: 'secretpassword' })
export default class SecretPassword extends VuexModule {
  @Action({ rawError: true })
  async FindUser(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FIND_USER_SUBPASS,
        method: M_POST,
        data: criteria,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Find user failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Find user failed');
    }
  }

  @Action({ rawError: true })
  async ResetSubPassword(username: IUsername) {
    try {
      const { data } = await axios({
        url: BASE_URL + RESET_SUBPASS,
        method: M_POST,
        data: username
      });

      assertOk(data, 'Reset sub password failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Reset sub password failed');
    }
  }

  @Action({ rawError: true })
  async FecthResetSubPassLog(username: IUsername) {
    try {
      const { data } = await axios({
        url: BASE_URL + FETCH_RESET_SUBPASS_LOG,
        method: M_POST,
        data: username
      });

      assertOk(data, 'Fetch reset sub password log failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch reset sub password log failed');
    }
  }
}
